import { ActionFunctionArgs } from "react-router-dom";
import * as Yup from "yup";
import { HTTPError } from "ky";
import { processYupErrors } from "@/helpers/yup-errors";
import { updateInvoiceStatus } from "@/api/invoice";
import { InvoiceStatus } from "@/entities/invoice-status";
import { assertParameterExists } from "@/helpers/loader-guards";

export async function action({ params, request }: ActionFunctionArgs) {
  assertParameterExists(params.invoice);

  let input;

  try {
    input = await Yup.object()
      .shape({
        invoiceId: Yup.string().required(),
        status: Yup.string().required(),
      })
      .validate(Object.fromEntries((await request.formData()).entries()), { abortEarly: false });
  } catch (e) {
    if (e instanceof Yup.ValidationError) {
      return {
        status: 422,
        errors: processYupErrors(e),
      };
    }

    throw e;
  }

  try {
    await updateInvoiceStatus(input.invoiceId, input.status as InvoiceStatus);

    return { status: 201 };
  } catch (e) {
    if (e instanceof HTTPError && e.response.status === 422) {
      return {
        status: 422,
        errors: (await e.response.json()).errors,
      };
    }

    return { status: 500 };
  }
}
